import React from "react";

import { images, data } from "../../constants";
import { SubHeading, MenuItem } from "../../components";
import "./SpecialMenu.css";
import "../Header/Header.css";

const SpecialMenu = () => (
	<div>
		<div className="app__specialMenu flex__center section__padding" id="menu">
			<div className="app__specialMenu-overlay flex__center">
				<img src={images.M} loading="lazy" alt="M" />
			</div>

			<div className="app__specialMenu-content">
				<div className="app__specialMenu-title">
					<h1 className="headtext__cormorant">Today's Special</h1>
					<SubHeading title="Menu that fits your palatte" />
				</div>

				<div className="app__specialMenu-menu">
					<div className="app__specialMenu-menu_wines flex__center">
						<p className="app__specialMenu-menu_heading">Wine & Beer</p>

						<div className="app__specialMenu-menu_items">
							{data.wines.map((wine) => (
								<p className="menuItem" style={{ color: "#dcca87" }}>
									{wine.title}
								</p>
							))}
						</div>
					</div>

					<div className="app__specialMenu-menu_img">
						<img src={images.menu} loading="lazy" alt="menu img" />
					</div>

					<div className="app__specialMenu-menu_cocktails flex__center">
						<p className="app__specialMenu-menu_heading">Cocktails</p>

						<div className="app__specialMenu-menu_items">
							{data.cocktails.map((cocktail) => (
								<p className="menuItem" style={{ color: "#dcca87" }}>
									{" "}
									{cocktail.title}{" "}
								</p>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
);
export default SpecialMenu;
